import { render, staticRenderFns } from "./WinnerListTableForm.vue?vue&type=template&id=524bb122&scoped=true&"
import script from "./WinnerListTableForm.vue?vue&type=script&lang=js&"
export * from "./WinnerListTableForm.vue?vue&type=script&lang=js&"
import style0 from "./WinnerListTableForm.vue?vue&type=style&index=0&id=524bb122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524bb122",
  null
  
)

export default component.exports